<template>
  <div class="chartModel">
    <div class="chart-header">
      <div class="chart-header-title">温湿度时程曲线图</div>
      <div class="chart-header-content">
        <div class="select-time">
          <el-date-picker
            size="small"
            v-model="choseTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="getData"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div
      class="chart-middle"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.1)">
      <div id="thChart"></div>
    </div>
    <div class="chart-bottom">

    </div>
  </div>
</template>

<script>
  import { getThermList } from "@/api/warehouse";
  import * as echarts from 'echarts';
  import { formatDate, formatTime } from "@/util/util"
  export default {
    name: "chartModel",
    props:{
      chartModal:Object
    },
    data(){
      return{
        loading:true,
        chartData:[],
        option : {
          title: {
            text: '',
            subtext: '',
            // left: 'center',
            // align: 'right',
            textStyle: {
              color: '#74c8fe'
            }
          },
          grid: {
            bottom: 80
          },
          toolbox: {
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              restore: {},
              saveAsImage: {}
            }
            },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              animation: false,
              label: {
                backgroundColor: '#505765'
              }
            }
          },
          legend: {
            data: ['温度', '湿度'],
            // left: 10,
            textStyle:{
              fontSize: 12,//字体大小
              color: '#74c8fe'//字体颜色
            },
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 65,
              end: 85
            },
            {
              type: 'inside',
              realtime: true,
              start: 65,
              end: 85
            }
            ],
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLine: {onZero: false},
              axisLabel: {
                show: true,
                textStyle: {
                  color:'#0ac8d5',  //更改坐标轴文字颜色
                  fontSize : 12     //更改坐标轴文字大小
                }
              },
              data: []
            }
          ],
          yAxis: [
            {
              name: '温度(℃)',
              type: 'value',
              // max: 50,
              axisLabel: {
                show: true,
                textStyle: {
                  color:'#0ac8d5',  //更改坐标轴文字颜色
                  fontSize : 12     //更改坐标轴文字大小
                }
              },
              nameTextStyle: {
                color: "#0ac8d5",
                fontSize: "12",
                align: "left"
              },
            },
            {
              name: '湿度(RH%)',
              // nameLocation: 'start',
              // inverse: true,
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color:'#74c8fe',  //更改坐标轴文字颜色
                  fontSize : 12     //更改坐标轴文字大小
                }
              },
              nameTextStyle: {
                color: "#0ac8d5",
                fontSize: "12",
                align: "left"
              },
            }
          ],
          series: [
            {
              name: '温度',
              type: 'line',
              lineStyle: {
                color: {
                  type: "linear",
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 1,
                      color: "#9e30e7" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgb(0,0,0,0)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgb(0,0,0,0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              emphasis: {
                focus: 'series'
              },
              markArea: {
                silent: true,
                itemStyle: {
                  opacity: 0.3
                }
              },
              data: []
            },
            {
              name: '湿度',
              type: 'line',
              yAxisIndex: 1,
              areaStyle: {
                color: {
                  type: "linear",
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgb(0,0,0,0)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgb(0,0,0,0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              lineStyle: {
                width: 2
              },
              emphasis: {
                focus: 'series'
              },
              markArea: {
                silent: true,
                itemStyle: {
                  opacity: 0.3
                }
              },
              data: []
        }
        ]
        },
        choseTime:[],
        startTime:"",
        endTime:""
      }
    },
    created() {
      this.initTime();
    },
    mounted() {
      this.getData();
    },
    methods:{
      initTime(){
        let self = this;
        // 获取当前时间
        let tempTime = [];
        const startDate = formatDate(new Date());
        // 30天：2592000000
        const endDate = formatDate(new Date() - 2505600000);
        tempTime[0] = endDate + ' 00:00:00';
        tempTime[1] = startDate + ' 23:59:59';
        self.$set(self,"choseTime",tempTime)
      },
      getData(){
        let self = this;
        self.loading = true;
        let stime = self.choseTime[0].toString()
        let etime = self.choseTime[1].toString()
        let params = {
          depotId:self.chartModal.depotId,
          startTime: stime,
          endTime: etime
        };
        getThermList(params).then(res =>{
          if(res.code == '200'){
            this.paintingCharts(res.data);
          }
          self.loading = false;
        }).catch(err => {
          self.loading = false;
          self.$message.error(err.msg || err.message || "网络请求错误")
        })
      },
      paintingCharts(val) {
        let self = this;
        if (val.dateTimes) {
          self.option.xAxis[0].data = val.dateTimes.map(function (str) {
            return str.replace('T', '\n');
          });
        }
        self.option.series[0].data = val.temp || [];
        self.option.series[1].data = val.hum || [];

        self.myChart = echarts.init(document.getElementById("thChart"));
        self.myChart.clear();
        self.myChart.setOption(self.option,true);
      },
      edit(){

      },

    }
  }
</script>

<style lang="less" scoped>
  .chartModel{
    color: #74c8fe;
    .chart-header{
      width: 100%;
      text-align: center;
      .chart-header-title{
        width: 100%;
        font-size: 24px;
      }
      .chart-header-content{
        height: 80px;
        line-height: 80px;
        width: 100%;
        .select-time{
          float: right;
          margin-right: 20px;
          font-size: 12px;
          display: inline-block;
        }
        .edit-but{
          float: right;
          display: inline-block;
          /deep/ .el-button{
            color: #74c8fe;
          }
          /deep/ .el-button:hover{
            background-color: #00a8ff;
          }
        }
      }
    }
    .chart-middle{
      margin-top: 10px;
      #thChart{
        width: 100%;
        height: 560px;
      }
    }
    .chart-bottom{
      /*height: 80px;*/

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/chartModel.vue